import type { Product } from '@shopgnd/shared';

/** Max shop categories per product (primary + additional). */
export const MAX_PRODUCT_CATEGORIES = 8;

/** Unique non-empty ids; first entry is the primary category (`categoryId`). */
export function normalizeProductCategoryIds(
  input?: string | string[] | null,
): string[] {
  const raw = Array.isArray(input) ? input : input ? [input] : [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const id of raw) {
    const trimmed = id?.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
    if (out.length >= MAX_PRODUCT_CATEGORIES) break;
  }
  return out;
}

export function productCategoryIds(product: Pick<Product, 'categoryId' | 'categoryIds'>): string[] {
  const fromArray = normalizeProductCategoryIds(product.categoryIds);
  if (fromArray.length > 0) return fromArray;
  return normalizeProductCategoryIds(product.categoryId);
}

export function productMatchesCategoryFilter(
  product: Pick<Product, 'categoryId' | 'categoryIds'>,
  allowedIds: string[],
): boolean {
  if (allowedIds.length === 0) return true;
  const allowed = new Set(allowedIds);
  return productCategoryIds(product).some((id) => allowed.has(id));
}
